module.exports = __webpack_public_path__ + "img/crypto-eos.214c3049.svg";